'use strict';
/**
*  Module  文件服务模块
*  creaytBy ly
*  time 2016/4/20
* Description
*/
angular.module('folderServiceModule', [
	"folderfileUploadModule",
	'websiteCloudNewFileModule'
	]).controller('folderServiceCtrl', function(){
	
});